import React from "react";
import styled from "styled-components";
import { Molecule, Wrapper } from "AppReact";
import { LogoPng, LogoSvg } from "./atoms";

const LogoWrapper = Wrapper(styled.div`
    padding: 10px;
    border: 1px solid #EEEEEE;
    border-radius: 50%;
    background: white;
`)

const template = styled.div`
    padding: 28px;
    background: #EEEEEE;
    border: 1px solid #EEEEEE;
    border-radius: 50%;
    background: #FCFCFC;
`;

export default Molecule({
    template,
    atoms: [
        {
            wrapper: LogoWrapper,
            name: 'Logo',
            atoms: [
                {
                    component: LogoPng,
                    name: 'LogoPng',
                    displayValue: ({ src }) => src,
                    renderIf: ({ src }) => !!src,
                },
                {
                    component: LogoSvg,
                    name: 'LogoSvg',
                    renderIf: ({ icon }) => !!icon,
                    displayValue: ({ icon }) => icon,
                }
            ]
        },

    ],
})
